import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from 'src/app/services/preferences.service';

@Component({
  selector: 'app-values-add',
  templateUrl: './values-add.component.html',
  styleUrls: ['./values-add.component.css']
})
export class ValuesAddComponent implements OnInit {
  valuesAddForms!:FormGroup;
  submitted:any = false;
  token: any;
  constructor(public router: Router,
    private prefrencesService: PreferencesService,
    private toastr : ToastrService,
    private activateroute: ActivatedRoute,
    private formBuilder : FormBuilder) { }

  ngOnInit(): void {
    this.valuesAddForms = this.formBuilder.group({
      name: ['',[Validators.required,this.prefrencesService.noSpacesValidator]],
      image:['']
    });
  }


  get addForm() {return this.valuesAddForms.controls}

  letterOnly(event:any) {
    var charCode = event.keyCode;

    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8)

        return true;
    else
        return false;
}

image:any
uploadFile(e:any){
  this.image=e.target.files[0]
  this.valuesAddForms.value.image = this.image
}

  onSubmit(){
    this.submitted = true;
    if (this.valuesAddForms.invalid) {
      return;
    }
    this.token = localStorage['token'];
    let formData = new FormData()
    formData.append('name',this.valuesAddForms.get('name')?.value)
    formData.append('image',this.image)
    this.prefrencesService.addValues(formData,this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.toastr.success(res.message);
        this.router.navigate(['/values-list']);
        this.valuesAddForms.reset();
        this.submitted = false;
      }
    });
  }

}
